import { render, staticRenderFns } from "./NavigationMenuItemsListItemCard.vue?vue&type=template&id=79fcbf96"
import script from "./NavigationMenuItemsListItemCard.vue?vue&type=script&lang=js"
export * from "./NavigationMenuItemsListItemCard.vue?vue&type=script&lang=js"
import style0 from "./NavigationMenuItemsListItemCard.vue?vue&type=style&index=0&id=79fcbf96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports